import React from 'react';
import { Link } from 'react-router-dom';
import './card.css';

const Card = ({ price, name, urlImage, id }) => {
  return (
    <div className="col-md-4 col-sm-6 col-12 d-flex justify-content-center">
      <div className="card">
        <Link to={`/re-store/shop/product/${id}`}>
          <img src={urlImage} className="card-img-top card-image" alt="..." />
        </Link>
        <div className="card-body">
          <h5 className="card-title">{name}</h5>
          <p className="card-text">${price}</p>
          <button className="btn btn-primary btn-add-cart">
            <Link to={`/re-store/shop/product/${id}`}>Buy now</Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
